import { useUser } from '@auth-v2';
import { useAtomValue } from 'jotai';

import { formatPresentationDate } from '@core';
import { useActivity, useUserName } from '@queries';
import { activityIdAtom } from '@store';
import { ArrowCounterClockwiseIcon, ClockClockwiseIcon } from '@ui';

import * as css from './style.css';

const formatDate = (date: string | undefined) => {
    if (!date) return 'N/A';
    return formatPresentationDate(date);
};

const formatTime = (date: string | undefined) => {
    if (!date) return 'N/A';
    const timeSplit = date.split('T')[1]?.split(':');
    return timeSplit ? `${timeSplit[0]}:${timeSplit[1]}` : 'N/A';
};

const UserName = ({ userId }: { userId: string }) => {
    const { data: userName } = useUserName(userId);
    return <div className={css.userName}>Golfer: {userName ?? 'N/A'}</div>;
};

type OldActivityTopBarProps = {
    onBack: () => void;
};

const OldActivityTopBar = ({ onBack }: OldActivityTopBarProps) => {
    const activityId = useAtomValue(activityIdAtom);
    const { data: activity } = useActivity(activityId);
    const { data: user } = useUser();
    const isAnotherUser = activity?.userId && activity?.userId !== user?.id;

    return (
        <div className={css.bar}>
            <div className={css.content}>
                <div>
                    <button onClick={onBack} className={css.group}>
                        <ArrowCounterClockwiseIcon />
                        <span>Back</span>
                    </button>
                </div>
                <span>{formatDate(activity?.startTime)}</span>
                <div className={css.group}>
                    <ClockClockwiseIcon />
                    <span>{formatTime(activity?.startTime)}</span>
                </div>
                {isAnotherUser && <UserName userId={activity?.userId} />}
            </div>
        </div>
    );
};
export default OldActivityTopBar;
